<script setup>

import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import AddBacklinkButton from "@/components/backlinks/partials/AddBacklinkButton.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import SearchInput from "@/components/global-themed/SearchInput.vue";

const store = useStore();

const search = computed(() => store.getters['backlinks/search']);
const mode = computed(() => store.getters['backlinks/mode']);
const activeTab = computed(() => store.getters['backlinks/activeTab']);

const onSearchInput = (value) => {
  store.dispatch('backlinks/setSearch', value);
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-center tw-py-8 tw-text-grey-dark">
    <div class="tw-col-span-2">
      <SelectInput
        @input="(e) => store.dispatch('backlinks/setMode', e.target.value)"
      >
        <option
          value="basic"
          :selected="mode === 'basic'"
        >
          Simple Mode
        </option>
        <option
          value="advanced"
          :selected="mode === 'advanced'"
        >
          Advanced Mode
        </option>
      </SelectInput>
    </div>

    <div class="tw-col-span-4">
      <SearchInput
        v-model="search"
        placeholder="Search Backlink"
        @update:model-value="onSearchInput"
      />
    </div>

    <div class="tw-col-span-6 tw-flex tw-items-center tw-justify-end">
      <DefaultButton
        variant="primary-inverted"
        as="a"
        target="_blank"
        class="py-2 px-4 !tw-border"
        href="/backlinks/export"
        size="small"
        :class="{
          'tw-mr-8' : activeTab === 'live'
        }"
      >
        <span class="tw-font-semibold tw-antialiased">Export</span>
        <svg-vue
          icon="icons/download"
          class="tw-w-5 tw-h-5 tw-ml-2"
        />
      </DefaultButton>

      <AddBacklinkButton
        v-if="activeTab === 'live'"
      />
    </div>
  </div>
</template>

